import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatPaginator, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { DatePipe } from '@angular/common';
import { ExcelService } from 'src/app/service/excel.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as _moment from 'moment';

export interface StandardElement {
  name: string;
  dueAmount: string;
}

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class PaymentListComponent implements OnInit {
  displayedColumns: string[] = ['name','date','dueAmount','cd'];
  dataSource:MatTableDataSource<any>=new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  tblLoading=false;
  itemTotal=0;
  isSubmitted=false;
  isSuccess=false;
  isError=false;
  message='';
  inputFormGroup:FormGroup;
  selectFormGroup:FormGroup;
  isGreater=false;
  isDisabled=false;
  startDate='';
  endDate='';
  srNo=0;
  totalBalance:any;
  search='';


  constructor(private api:ApiService,private route:ActivatedRoute,private formBuilder:FormBuilder,private excelService:ExcelService,private datePipe:DatePipe,public dialog: MatDialog) {
    this.selectFormGroup=this.formBuilder.group({
      startDate:[''],
      endDate:['']
    });
   }

  ngOnInit() {
    this.route.data.subscribe(data=>{
      this.itemTotal=parseInt(data.payment[0].total);
      this.dataSource.data=data.payment[0].data;
      this.totalBalance=data.payment[0].totals;
    },(error)=>{

    });
   
  }

  viewReceipt(id)
  {
    const dialogRef = this.dialog.open(DialogReceipt,{
      data: this.dataSource.data[id]
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  tblItmPageChange(event)
  {
    let start=(event.pageIndex>0)?(event.pageSize*event.pageIndex):event.pageIndex;
    this.srNo=start;
    let postData={start:start,length:event.pageSize};
    this.api.get("transaction?orderBy=tid_desc&start="+start+"&length="+event.pageSize).subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
    },(error)=>{

    });
  }

  counter(i)
 {
   let num=i+1;
   return this.srNo+num;
 }

  refreshTable(start,pageSize)
  {
    if(this.startDate!="" && this.endDate!="")
    {
      this.api.get("transaction?orderBy=tid_desc&start="+start+"&length="+pageSize+"&startDate="+this.startDate+"&endDate="+this.endDate).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        this.dataSource.data=data.data;
        this.totalBalance=data.totals;
      },(error)=>{

      });
    }
    else
    {
      this.api.get("transaction?orderBy=tid_desc&start="+start+"&length="+pageSize).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        this.dataSource.data=data.data;
        this.totalBalance=data.totals;
      },(error)=>{

      });
    }
    
  }

  dateTranform()
  {
    let dt=new Date();
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  dateValTranform(dt)
  {
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  fetch(form)
  {
    this.startDate=(form.value.startDate!="")?this.datePipe.transform(form.value.startDate,"dd/MM/yyyy"):'';
    this.endDate=(form.value.endDate!="")?this.datePipe.transform(form.value.endDate,"dd/MM/yyyy"):'';
    this.refreshTable(0,10);
  }

  exportAsXLSX():void {
    if(this.startDate!="" && this.endDate!="")
    {
      this.api.get("transaction?export=excel&startDate="+this.startDate+"&endDate="+this.endDate).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        data.data.push({"Name":"Total Credit Amount","Date":data.totals.totalCredit,"Amount":"Total Debit Amount","Type":data.totals.totalDebit});
        this.excelService.exportAsExcelFile(data.data, 'passbook');
      },(error)=>{
  
      });
    }
    else
    {
      let url='';
      if(this.search.length>1)
      {
        url="transaction?export=excel&name="+this.search;
      }
      else
      {
        url="transaction?export=excel";
      }
      this.api.get(url).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        data.data.push({"Name":"Total Credit Amount","Date":data.totals.totalCredit,"Amount":"Total Debit Amount","Type":data.totals.totalDebit});

        this.excelService.exportAsExcelFile(data.data, 'passbook');
      },(error)=>{
  
      });
    }
    
    
 }

 reset()
  {
    window.location.reload();
  }

 searchname(e)
 {
   let url='';
   if(e.target.value.length>1)
   {
    this.search=e.target.value;
    url="transaction?orderBy=tid_desc&start=0&length=10&name="+e.target.value;
   }
   else if(e.target.value.length==0)
   {
     this.search='';
     url="transaction?orderBy=tid_desc&start=0&length=10";
   }

   this.api.get(url).subscribe(data=>{
    this.itemTotal=parseInt(data.total);
    this.dataSource.data=data.data;
    this.totalBalance=data.totals;
  },(error)=>{

  });
    
 }

}

@Component({
  selector: 'view-dialog',
  templateUrl:'./view-receipt.html',
  styleUrls: ['./payment-list.component.css'],
})
export class DialogReceipt {
  public providerAmount=0;
  public paid=0;
  constructor(private api:ApiService,@Inject(MAT_DIALOG_DATA) public data: any,private datePipe:DatePipe) {
        
  }

  convertNumberToWords(num) {
    let n;
    var a = ['','One ','Two ','Three ','Four ', 'Five ','Six ','Seven ','Eight ','Nine ','Ten ','Eleven ','Twelve ','Thirteen ','Fourteen ','Fifteen ','Sixteen ','Seventeen ','Eighteen ','Nineteen '];
    var b = ['', '', 'Twenty','Thirty','Forty','Fifty', 'Sixty','Seventy','Eighty','Ninety'];
    if ((num = num.toString()).length > 9) return 'overflow';
    n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
    return str;

  }
 
  dateValTranform(dt)
  {
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  receiptNo(no)
  {
    let num=no.toString();
    if(num.length<2)
    {
      return '00'+num;
    }
    else if(num.length<3)
    {
      return '0'+num;
    }
    else
    {
      return num;
    }

  }

  print()
  {
    window.print();
  }
  
}